import React, { useEffect, useState } from "react";
import API from "../../../utils/API";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { NavLink } from "react-router-dom";
import { Form } from "react-bootstrap";

const FilterSidebar = ({
  slug,
  onFilterChange,
  setAllProducts,
  filterCounts,
}) => {
  const [categories, setCategories] = useState([]);
  const [minMaxPrice, setMinMaxPrice] = useState([0, 50000]);
  const [priceRange, setPriceRange] = useState([0, 50000]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedSizes, setSelectedSizes] = useState([]);
  const [isCategoryCollapsed, setIsCategoryCollapsed] = useState(false);
  const [isColorCollapsed, setIsColorCollapsed] = useState(false);
  const [isSizeCollapsed, setIsSizeCollapsed] = useState(false);

  const formatINR = (value) => `₹${value.toLocaleString("en-IN")}`;

  useEffect(() => {
    if (slug) {
      loadCategoryMenu();
      fetchPriceRangeFromAPI();
    }
  }, [slug]);

  const loadCategoryMenu = async () => {
    try {
      const res = await API.get("v1/site/category/menu");
      if (res.data.status === "1") {
        setCategories(res.data.data);
      }
    } catch (err) {
      console.error("Category menu error:", err);
    }
  };

  const fetchPriceRangeFromAPI = async () => {
    try {
      const res = await API.get(`v1/site/item/category/${slug}/1/100`);
      if (res.data.status === "200") {
        const products = res.data.data || [];
        setAllProducts(products);

        const prices = products
          .map((item) =>
            parseFloat(item.discount_sales_rate || item.salesrate || 0)
          )
          .filter((p) => !isNaN(p));

        if (prices.length > 0) {
          const min = Math.floor(Math.min(...prices));
          const max = Math.ceil(Math.max(...prices));
          setMinMaxPrice([min, max]);
          setPriceRange([min, max]);
          onFilterChange("minPrice", min.toFixed(2));
          onFilterChange("maxPrice", max.toFixed(2));
        }
      }
    } catch (err) {
      console.error("Error fetching price range:", err);
    }
  };

  const handleSliderChange = (range) => {
    setPriceRange(range);
  };

  const handleSliderAfterChange = (range) => {
    const [min, max] = range;
    onFilterChange("minPrice", min.toFixed(2));
    onFilterChange("maxPrice", max.toFixed(2));
  };

  const handlePriceReset = () => {
    setPriceRange(minMaxPrice);
    onFilterChange("minPrice", minMaxPrice[0].toFixed(2));
    onFilterChange("maxPrice", minMaxPrice[1].toFixed(2));
  };

  const handleColorChange = (color) => {
    setSelectedColors((prev) =>
      prev.includes(color)
        ? prev.filter((item) => item !== color)
        : [...prev, color]
    );
  };

  const handleSizeChange = (size) => {
    setSelectedSizes((prev) =>
      prev.includes(size)
        ? prev.filter((item) => item !== size)
        : [...prev, size]
    );
  };

  const handleRemoveFilter = (type, value) => {
    let updatedSelection;
    if (type === "color") {
      updatedSelection = selectedColors.filter((color) => color !== value);
      setSelectedColors(updatedSelection);
      onFilterChange("color", updatedSelection);
    } else if (type === "size") {
      updatedSelection = selectedSizes.filter((size) => size !== value);
      setSelectedSizes(updatedSelection);
      onFilterChange("size", updatedSelection);
    }
  };

  const handleClearAllFilters = () => {
    setSelectedColors([]);
    setSelectedSizes([]);
    setPriceRange(minMaxPrice);
    onFilterChange("color", []);
    onFilterChange("size", []);
    onFilterChange("minPrice", minMaxPrice[0].toFixed(2));
    onFilterChange("maxPrice", minMaxPrice[1].toFixed(2));
  };

  useEffect(() => {
    if (selectedColors.length > 0) {
      onFilterChange("color", selectedColors);
    }
  }, [selectedColors]);

  useEffect(() => {
    if (selectedSizes.length > 0) {
      onFilterChange("size", selectedSizes);
    }
  }, [selectedSizes]);

  return (
    <div className="canvas-wrapper shadow" style={{ fontSize: "14px" }}>
      <header
        className="canvas-headertf-md-hidden shadow-0 mb-3"
        style={{ padding: "10px 15px", borderBottom: "1px solid #ddd" }}
      >
        <div className="filter-icon d-flex justify-content-between align-items-center">
          <div style={{ fontSize: "18px", fontWeight: "600" }}>Filters</div>
          <div>
            <a
              className="fs-13 text-primary text-uppercase"
              style={{
                fontWeight: "700",
                cursor: "pointer",
                fontSize: "13px",
              }}
              onClick={handleClearAllFilters}
            >
              CLEAR ALL
            </a>
          </div>
        </div>
      </header>

      <div className="canvas-body px-3">
        {/* Selected Filters */}
        {(selectedColors.length > 0 || selectedSizes.length > 0) && (
          <div className="mb-2">
            {[...selectedColors, ...selectedSizes].map((filter, i) => (
              <span
                key={i}
                className="hadge border me-2 mb-2"
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  padding: "1px 8px",
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                {filter}
                <button
                  onClick={() =>
                    handleRemoveFilter(
                      selectedColors.includes(filter) ? "color" : "size",
                      filter
                    )
                  }
                  style={{
                    marginLeft: "8px",
                    cursor: "pointer",
                    border: "none",
                    background: "none",
                    fontWeight: "bold",
                    color: "#555",
                    lineHeight: "1",
                  }}
                >
                  <i className="fas fa-times"></i>
                </button>
              </span>
            ))}
          </div>
        )}

        {/* Categories */}
        <div className="widget-facet mb-3 mt-2">
          <div
            className="facet-title d-flex justify-content-between align-items-center"
            onClick={() => setIsCategoryCollapsed(!isCategoryCollapsed)}
            style={{ cursor: "pointer", fontWeight: "600" }}
          >
            <span>Categories</span>
            <span
              className={`icon ${
                isCategoryCollapsed ? "icon-arrow-down" : "icon-arrow-up"
              }`}
            ></span>
          </div>
          <div
            className={`collapse ${!isCategoryCollapsed ? "show" : ""} mt-2`}
          >
            {categories.map((item, i) =>
              item.categoryname && item.categoryname.length > 3 ? (
                <NavLink
                  key={item.slug || i}
                  to={`/category/${item.slug}`}
                  className="dropdown-item d-flex justify-content-between"
                  style={{
                    fontSize: "13px",
                    padding: "4px 10px",
                    color: "#6a6868",
                    fontWeight: "600",
                    textTransform: "capitalize",
                  }}
                >
                  <div>
                    <span>{item.categoryname}</span>{" "}
                    <span className="fs-11 text-muted">
                      ({item.item_count})
                    </span>
                  </div>

                  <div>
                    <i class="fa fa-chevron-right me-4"></i>
                  </div>
                </NavLink>
              ) : null
            )}
          </div>
        </div>

        {/* Price Filter */}
        <div className="widget-facet mb-4">
          <div className="facet-title" style={{ fontWeight: "600" }}>
            Price
            <p
              className="text-primary fw-bolder mt-2 mb-2"
              onClick={handlePriceReset}
              style={{ fontSize: "12px" }}
            >
              Reset Price
            </p>
          </div>
          <Slider
            range
            min={minMaxPrice[0]}
            max={minMaxPrice[1]}
            step={500}
            value={priceRange}
            onChange={handleSliderChange}
            onAfterChange={handleSliderAfterChange}
          />
          <div className="caption-price mt-2 d-flex justify-content-between">
            <span>{formatINR(priceRange[0])}</span>
            <span>{formatINR(priceRange[1])}</span>
          </div>
        </div>

        {/* Offer Filter */}
        <div
          className="form-check p-0 widget-facet pb-5"
          style={{ fontSize: "13px" }}
        >
          <Form.Check
            type="checkbox"
            label={
              <>
                Products With Offer{" "}
                {filterCounts && filterCounts.offerOnly > 0 && (
                  <span className="fs-11 text-muted">
                    ({filterCounts.offerOnly})
                  </span>
                )}
              </>
            }
            onChange={(e) => onFilterChange("offerOnly", e.target.checked)}
          />
        </div>

        {/* Color Filter */}
        <div className="widget-facet mb-4">
          <div
            className="facet-title d-flex justify-content-between align-items-center"
            onClick={() => setIsColorCollapsed(!isColorCollapsed)}
            style={{ cursor: "pointer", fontWeight: "600" }}
          >
            <span>Color</span>
            <span
              className={`icon ${
                isColorCollapsed ? "icon-arrow-down" : "icon-arrow-up"
              }`}
            ></span>
          </div>

          <div className={`collapse mt-2 ${!isColorCollapsed ? "show" : ""}`}>
            {selectedColors.length > 0 && (
              <button
                className="hadge mb-2"
                onClick={() => {
                  setSelectedColors([]);
                  onFilterChange("color", []);
                }}
                style={{
                  marginLeft: "8px",
                  cursor: "pointer",
                  border: "none",
                  background: "none",
                  fontSize: "10px",
                  color: "#000",
                  lineHeight: "1",
                  padding: "8px 5px",
                }}
              >
                <span className="me-2">
                  {selectedColors.length > 1 ? "Clear All" : "Clear"}
                </span>
                <i className="fas fa-times"></i>
              </button>
            )}
            {filterCounts &&
              filterCounts.color &&
              Object.keys(filterCounts.color).map((color) => {
                const count = filterCounts.color[color] || 0;

                return (
                  <div
                    key={color}
                    className="form-check"
                    style={{ fontSize: "13px" }}
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`color-${color}`}
                      checked={selectedColors.includes(color)}
                      onChange={() => handleColorChange(color)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`color-${color}`}
                    >
                      <span className="text-capitalize">{color}</span>{" "}
                      {count > 0 && (
                        <span className="fs-11 text-muted">({count})</span>
                      )}
                    </label>
                  </div>
                );
              })}
          </div>
        </div>

        {/* Size Filter */}
        <div className="widget-facet mb-3">
          <div
            className="facet-title d-flex justify-content-between align-items-center"
            onClick={() => setIsSizeCollapsed(!isSizeCollapsed)}
            style={{ cursor: "pointer", fontWeight: "600" }}
          >
            <span>Size</span>
            <span
              className={`icon ${
                isSizeCollapsed ? "icon-arrow-down" : "icon-arrow-up"
              }`}
            ></span>
          </div>
          {selectedSizes.length > 0 && (
            <button
              className="hadge mb-10"
              onClick={() => {
                setSelectedSizes([]);
                onFilterChange("color", []);
              }}
              style={{
                marginLeft: "8px",
                cursor: "pointer",
                border: "none",
                background: "none",
                fontSize: "10px",
                color: "#000",
                lineHeight: "1",
                padding: "8px 5px",
              }}
            >
              <span className="me-4">
                {selectedSizes.length > 1 ? "Clear All" : "Clear"}
              </span>
              <i className="fas fa-times"></i>
            </button>
          )}
          <div className={`collapse ${!isSizeCollapsed ? "show" : ""} mt-2`}>
            {[
              [25, 30],
              [30, 35],
              [35, 40],
              [40, 45],
            ].map(([min, max]) => {
              const label = `${min}-${max}`;
              return (
                <div
                  key={label}
                  className="form-check"
                  style={{ fontSize: "13px" }}
                >
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={label}
                    checked={selectedSizes.includes(label)}
                    onChange={() => handleSizeChange(label)}
                  />
                  <label className="form-check-label" htmlFor={label}>
                    {label}
                  </label>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterSidebar;
